import { gql } from '@apollo/client';

export const PaginatedPacksAndRepacksQuery = gql`
    query PaginatedPacksAndRepacks(
        $take: Int
        $page: Int
        $query: String
        $offset: Int
    ) {
        paginatedPacksAndRepacks(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ... on Pack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    type
                }
                ... on Repack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    subType
                    type
                }
            }
            meta {
                totalRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;

export const PaginatedDownloadedPacksAndRepacksQuery = gql`
    query PaginatedDownloadedPacksAndRepacks(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedDownloadedPacksAndRepacksV2(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ... on Pack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    type
                }
                ... on Repack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    subType
                    type
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;

export const PaginatedFavoritedPacksAndRepacksQuery = gql`
    query PaginatedFavoritedPacksAndRepacks(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedFavoritedPacksAndRepacksV2(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ... on Pack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    type
                }
                ... on Repack {
                    guid
                    artworkUrl
                    backgroundColor
                    creatorSession
                    foregroundColor
                    isDownloaded
                    isExclusive
                    isFavorited
                    isFree
                    name
                    packState
                    premiumCodes
                    slug
                    subType
                    type
                }
            }
            meta {
                totalRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;
